import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';

interface IProps {
  isOpen: boolean;
  okText: string;
  okDisabled: boolean;
  onOk: () => void;
  onClose: any;
  headerText: string;
  fields?: any;
  children: any;
}

export default function QuickActionDialog({
  isOpen,
  okText,
  okDisabled,
  onOk,
  onClose,
  headerText,
  children,
  fields,
}: IProps) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      {/* Dialog header */}
      <Box display="flex" flexDirection="column" mt={2.5} mx={3}>
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClose}>
            <i className="ri-close-fill" style={{ fontSize: 24 }} />
          </IconButton>
        </Box>
        <Box display="flex" mt={1.5} px={3}>
          <Typography align="center" fontWeight={700} variant="subtitle1">
            {headerText}
          </Typography>
        </Box>
      </Box>
      <DialogContent sx={{ marginBottom: '0px' }}>{children}</DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          flexDirection: 'column',
          margin: '30px 16px',
        }}
      >
        {fields && (
          <Box display="flex" mb={4} width="100%">
            {fields}
          </Box>
        )}
        <Box display="flex" justifyContent="space-between" width="100%">
          <Button onClick={onClose}>Cancel</Button>
          <Button disabled={okDisabled} variant="contained" onClick={onOk}>
            {okText}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
